import React, { useState } from 'react';
import './Contact.css';

const contactDetails = [
  {
    icon: 'bi-geo-alt-fill',
    title: 'Our Address',
    lines: ['45/30, Udayaravi Road, Ittamadu,', 'Bengaluru Urban, Karnataka — 560085'],
  },
  {
    icon: 'bi-telephone-fill',
    title: 'Call Us',
    lines: ['9964264511', '8971116369'],
    isPhone: true,
  },
  {
    icon: 'bi-envelope-fill',
    title: 'Email Us',
    lines: ['airtechnoservices1@gmail.com'],
    isEmail: true,
  },
];

function Contact() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = e => {
    e.preventDefault();
    // Compose mailto link
    const mailto = `mailto:airtechnoservices1@gmail.com?subject=${encodeURIComponent(form.subject || 'Enquiry from Website')}&body=${encodeURIComponent(`Name: ${form.name}\nPhone: ${form.phone}\nEmail: ${form.email}\n\n${form.message}`)}`;
    window.location.href = mailto;
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
  };

  return (
    <section className="contact-section" id="contact">
      <div className="container">
        <div className="text-center mb-5">
          <div className="section-eyebrow">Get In Touch</div>
          <h2 className="section-title">Contact Us</h2>
          <p className="section-sub">Reach out for services, sales enquiries or AMC plans. We're happy to help.</p>
        </div>

        <div className="row g-4">
          {/* Contact info */}
          <div className="col-lg-4">
            <div className="contact-info-box">
              {contactDetails.map((c, i) => (
                <div className="contact-info-card" key={i}>
                  <div className="contact-info-icon">
                    <i className={`bi ${c.icon}`}></i>
                  </div>
                  <div>
                    <div className="contact-info-title">{c.title}</div>
                    {c.lines.map((line, j) => (
                      c.isPhone ? (
                        <a key={j} href={`tel:${line}`} className="contact-info-line contact-link d-block">{line}</a>
                      ) : c.isEmail ? (
                        <a key={j} href={`mailto:${line}`} className="contact-info-line contact-link d-block">{line}</a>
                      ) : (
                        <div key={j} className="contact-info-line">{line}</div>
                      )
                    ))}
                  </div>
                </div>
              ))}

              <div className="contact-tagline">
                <i className="bi bi-clock me-2"></i>
                Available Mon – Sat, 9 AM to 6 PM
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="col-lg-8">
            <div className="contact-form-box">
              <h5 className="form-box-title">Send Us an Enquiry</h5>

              {submitted && (
                <div className="form-success-msg">
                  <i className="bi bi-check-circle-fill me-2"></i>
                  Your email client has been opened. Thank you for reaching out!
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label ats-label">Your Name *</label>
                    <input
                      type="text" name="name" required
                      className="form-control ats-input"
                      placeholder="e.g. Rajesh Kumar"
                      value={form.name} onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label ats-label">Phone Number *</label>
                    <input
                      type="tel" name="phone" required
                      className="form-control ats-input"
                      placeholder="e.g. 9876543210"
                      value={form.phone} onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label ats-label">Email Address</label>
                    <input
                      type="email" name="email"
                      className="form-control ats-input"
                      placeholder="you@company.com"
                      value={form.email} onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label ats-label">Subject</label>
                    <select name="subject" className="form-select ats-input" value={form.subject} onChange={handleChange}>
                      <option value="">Select a topic...</option>
                      <option>Service Enquiry</option>
                      <option>Product Sales</option>
                      <option>AMC Plan</option>
                      <option>General Enquiry</option>
                    </select>
                  </div>
                  <div className="col-12">
                    <label className="form-label ats-label">Your Message *</label>
                    <textarea
                      name="message" required rows="5"
                      className="form-control ats-input"
                      placeholder="Describe your requirement, equipment type, location..."
                      value={form.message} onChange={handleChange}
                    />
                  </div>
                  <div className="col-12">
                    <button type="submit" className="btn-ats-primary w-100 form-submit-btn">
                      <i className="bi bi-send me-2"></i>Send Enquiry
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
